import DataCacheService from '@/shared/services/DataCacheService';
var validateBelgianVatNumber = function (value) {
    if (Number(value.slice(1, 2)) === 0)
        return false;
    var valueWithoutPrefix = value.length === 9 ? value : value.substring(2);
    var check = 97 - (Number(valueWithoutPrefix.slice(0, 8)) % 97);
    return check === Number(valueWithoutPrefix.slice(8, 10));
};
var validateVatNumber = function (value) {
    var _a;
    if (value === null || value === undefined || value === '')
        return true;
    var tenantConfiguration = (_a = DataCacheService.getDataCache()) === null || _a === void 0 ? void 0 : _a.tenantConfiguration;
    if (tenantConfiguration === 2)
        return true;
    var cleaned = value.replace(/[^0-9a-zA-Z]/g, '');
    if (cleaned.length <= 2)
        return false;
    if (cleaned.toLowerCase().startsWith('be')) {
        return validateBelgianVatNumber(cleaned);
    }
    return true;
};
export default validateVatNumber;
